import styled from "styled-components";
import { fonts } from "components/constants";

export const SingleScheduleWrapper = styled.div`
  button {
    width: 47%;
  }
  .no {
    background: #ffffff;
    border: 1px solid #17568b;
    border-radius: 2px;
    color: #496781;
  }
  .yes {
    // background: #8c3621;
  }
  p {
    font-size: 14px;
    line-height: 125%;
    font-family: ${fonts.giloryMedium};
    text-align: center;
  }
  .date {
    margin-bottom: 20px;
    font-family: ${fonts.gilorySemiBold};
  }
`;
